import React from 'react';
import { getSetup } from './getSetup';

export function videoSrcFetch(
    src: string,
    videoRef: React.MutableRefObject<any>,
    play?: boolean,
    then?: Function,
    error?: Function
) {
    const setup = getSetup();
    let fetchOptions: RequestInit | undefined = {
        method: 'GET',
        headers: {},
    };
    if (setup) {
        fetchOptions = {
            method: 'GET',
            headers: {
                Authorization: 'Basic ' + window.btoa(`ssp:${setup.password}`),
            },
        };
    }

	fetch(src, fetchOptions)
		.then(res => {
			if (!res.ok) {
				if (error) error();
				return null;
			}
			return res.blob();
		})
		.then(blob => {
			if (!blob || !videoRef.current) return;

			const video = videoRef.current as any;

			if (video._currentObjectUrl && video._currentObjectUrl.startsWith('blob:')) {
				try {
					URL.revokeObjectURL(video._currentObjectUrl);
				} catch {}
			}

			const newUrl = URL.createObjectURL(blob);
			video.src = newUrl;
			video._currentObjectUrl = newUrl;

			if (then) then();

			if (play === true) {
				video.play().catch(() => {});
			}
		})
		.catch(err => {
			if (error) error(err);
		});
}
